import { Config } from '.';

const config: Config = {
  env: 'dev',
  apiServerBase: `http://${window.location.hostname}:3001`,
  useMockData: false,
};

export default config;
